import { render, staticRenderFns } from "./pagsmile-card.vue?vue&type=template&id=351a5931&"
import script from "./pagsmile-card.vue?vue&type=script&lang=js&"
export * from "./pagsmile-card.vue?vue&type=script&lang=js&"
import style0 from "./pagsmile-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Ombudsman: require('/builds/pagsmile/front-end/pagsmile-web/components/Ombudsman.vue').default,HeaderTopToBr: require('/builds/pagsmile/front-end/pagsmile-web/components/HeaderTopToBr.vue').default,Header: require('/builds/pagsmile/front-end/pagsmile-web/components/Header.vue').default,Footer: require('/builds/pagsmile/front-end/pagsmile-web/components/Footer.vue').default})
